import React, { Component } from 'react'
import { Modal, Button } from 'antd'

export default class extends Component {
  state = {
    loading: false
  }

  handleOk = (e) => {
    this.setState({
      loading: true
    })

    const { list, id, deleteStorageAssignmentByArray, deleteStorageByArray, updateTable, closeModal } = this.props

    const guids = {
      guids: list.filter(item => item.guid ? item.guid : false).map(item => item.guid)
    }

    const ids = {
      ids: list.filter(item => !item.guid ? item : false).map(item => item.id)
    }

    Promise.all([deleteStorageAssignmentByArray(id, guids), deleteStorageByArray(ids)])
      .then(() => {
        this.setState({
          loading: false
        })

        updateTable({
          checkedList: [],
          indeterminate: false,
          checkAll: false
        })
        closeModal()
      })
  }

  handleCancel = (e) => {
    const { closeModal } = this.props
    closeModal()
  }

  render () {
    const { loading } = this.state
    const { status, list } = this.props

    return (
      <Modal
        wrapClassName='vertical-center-modal'
        width={320}
        visible={status}
        onCancel={this.handleCancel}
        destroyOnClose
        footer={[
          <Button key='back' onClick={this.handleCancel}>Cancel</Button>,
          <Button key='submit' type='red' loading={loading} onClick={this.handleOk}>Delete</Button>
        ]}
      >
        <h4>Are you sure you want to delete { list.length > 1 ? 'these files' : 'this file' }?</h4>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Modals/StorageDeleteLinksModal/StorageDeleteLinksModal.jsx